/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { SolutionRequestDto_Output } from '../models/SolutionRequestDto_Output';

export class DiscoveryEvaluationEvalSetService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Get Shopper Solution Request
   * This shopper as a fully-specified, directly-postable request.
   *
   * `engine` is left `None` so an unedited prefill runs on the production
   * default. Fields the de-identified dataset does not carry (zip, fips,
   * rating area) come back explicitly `null` rather than being silently
   * filled — a live run needs the caller to supply them, and seeing the
   * hole is how they find that out.
   * @param shopperKey
   * @returns SolutionRequestDto_Output Successful Response
   * @throws ApiError
   */
  public getShopperSolutionRequestInternalDiscoveryEvaluationEvalSetShoppersShopperKeySolutionRequestGet(
    shopperKey: string
  ): CancelablePromise<SolutionRequestDto_Output> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/internal/discovery/evaluation/eval-set/shoppers/{shopper_key}/solution-request',
      path: {
        shopper_key: shopperKey,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
